export default __webpack_public_path__ + "static/media/img.59b3ddf5.png";